<!-- eslint-disable max-lines -->
<template>
  <svg
    width="21.000000pt"
    height="100.000000pt"
    viewBox="0 0 100.000000 100.000000"
    xmlns="http://www.w3.org/2000/svg"
    style="vertical-align: middle"
  >
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#fefefe"
      stroke="none"
    >
      <path
        d="M0 500 l0 -500 500 0 500 0 0 500 0 500 -500 0 -500 0 0 -500z m670
335 c15 -8 43 -32 63 -54 l37 -41 12 -45 12 -46 33 -19 c17 -10 39 -33 49 -51
l17 -33 0 -40 0 -40 34 -49 34 -48 -6 -19 c-3 -10 -15 -22 -25 -25 -11 -3 -33
-19 -49 -36 l-29 -29 -43 0 -43 0 -28 -27 -28 -27 -38 0 c-20 0 -51 7 -69 14
l-31 14 -40 -28 c-45 -31 -95 -41 -147 -32 l-36 7 -42 43 c-23 23 -47 50 -54
58 -7 9 -18 18 -25 20 l-13 5 3 29 2 29 -39 16 -39 17 -17 32 -17 32 6 33 6
32 27 24 26 24 4 -12 c3 -7 14 -13 25 -13 l20 0 -7 28 -6 28 23 33 c13 19 39
42 58 53 l35 19 35 -6 35 -6 24 46 c26 50 63 81 120 102 l36 13 35 -6 c19 -3
46 -12 60 -19z"
      />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#3497da"
      stroke="none"
    >
      <path
        d="M529 856 c-56 -20 -94 -51 -119 -98 l-22 -43 -47 0 -48 0 -36 -28
-36 -27 -12 -33 -12 -34 -28 -10 -28 -11 -20 -33 c-50 -82 4 -179 99 -179 31
0 69 20 102 53 22 21 44 22 52 2 l5 -15 29 0 30 0 26 -34 c14 -19 26 -44 26
-55 l0 -21 -120 0 -120 0 0 -17 c0 -9 20 -36 45 -59 l44 -43 36 -7 c20 -3 56
-4 81 -1 l44 5 39 27 39 26 33 -16 32 -17 40 5 39 5 27 26 27 26 41 0 40 0 27
21 c14 11 26 27 26 35 l0 14 -52 1 c-29 1 -83 1 -120 -1 l-66 -2 -21 21 -21
21 6 14 c6 14 59 52 97 68 9 4 17 12 17 17 0 6 10 15 21 22 l21 11 29 -21 29
-21 24 6 25 6 6 26 c11 54 -25 131 -74 156 l-29 15 -6 33 c-3 18 -15 48 -26
66 l-20 32 -45 0 -46 0 3 32 3 32 -25 7 c-38 11 -71 9 -111 -5z m36 -176 l6
-20 60 0 60 0 5 -15 c4 -8 12 -15 20 -15 8 0 14 -7 14 -15 0 -31 -34 -150 -44
-157 -6 -4 -34 -8 -62 -8 l-52 0 -7 -17 -6 -18 -13 18 -13 17 -55 0 -54 0 -12
12 -12 12 0 94 0 93 10 20 11 19 69 0 69 0 6 -20z m-358 -117 c-4 -3 -10 -3
-14 0 -3 4 0 7 7 7 7 0 10 -3 7 -7z m-2 -23 c3 -5 15 -10 26 -10 10 0 19 -4
19 -10 l0 -10 -40 0 -40 0 0 -11 0 -10 -16 15 -15 16 13 14 c15 18 44 21 53 6z
m356 -243 c-1 -12 -15 -9 -19 4 l-4 12 12 -4 c6 -3 11 -8 11 -12z"
      />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#fcfbee"
      stroke="none"
    >
      <path
        d="M752 478 c-7 -7 -12 -18 -12 -25 l0 -13 -25 0 c-14 0 -25 -4 -25 -9
0 -6 -12 -16 -27 -23 l-28 -13 -3 -26 -3 -26 13 -10 13 -11 75 -2 c41 -1 110
-2 153 -1 l77 1 0 36 0 35 -31 46 -31 45 -7 -9 c-3 -5 -15 -12 -27 -15 l-21
-5 -12 18 -11 19 -28 0 c-15 0 -33 -5 -40 -12z"
      />
      <path
        d="M308 413 c-15 -20 -41 -38 -76 -53 l-23 -10 3 -28 3 -27 87 -8 87 -8
48 8 48 8 3 28 3 27 -15 6 c-9 3 -16 15 -16 25 l0 19 -24 6 c-14 3 -29 3 -34
0 -6 -3 -12 1 -16 9 l-5 15 -30 0 -30 0 -13 -17z"
      />
      <path d="M260 251 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z" />
      <path
        d="M565 229 c-9 -14 -2 -20 14 -10 l13 9 -10 6 c-6 3 -14 1 -17 -5z"
      />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#e0dfd7"
      stroke="none"
    >
      <path
        d="M421 551 c-12 -49 -21 -91 -21 -95 0 -3 67 -6 149 -6 l150 0 5 18 c9
29 36 153 36 163 l0 9 -149 0 -149 0 -21 -89z"
      />
      <path
        d="M821 460 c12 -16 26 -27 30 -24 l9 5 -16 25 c-9 13 -23 24 -30 24
l-15 0 22 -30z"
      />
      <path
        d="M903 443 c9 -9 19 -14 23 -11 10 10 -6 28 -24 28 l-16 0 17 -17z"
      />
      <path
        d="M747 413 l5 -13 -12 0 c-6 0 -8 -4 -5 -10 9 -15 25 -12 25 5 l0 15
17 0 c22 0 8 13 -16 15 l-19 2 5 -14z"
      />
      <path
        d="M425 400 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0
6 -10z"
      />
      <path
        d="M633 395 c-9 -25 2 -27 22 -5 l18 20 -17 0 c-9 0 -19 -7 -23 -15z"
      />
      <path
        d="M895 399 c-11 -17 1 -21 15 -4 l12 15 -10 0 c-6 0 -14 -5 -17 -11z"
      />
      <path
        d="M380 390 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4
-16 -10z"
      />
      <path
        d="M260 380 c0 -5 -13 -10 -28 -10 l-28 0 2 -27 c2 -46 4 -53 14 -53
l10 0 -6 25 -6 25 25 9 c14 5 28 14 31 20 4 6 13 8 21 4 l15 -5 0 11 0 11 -25
0 c-14 0 -25 -4 -25 -10z"
      />
      <path
        d="M693 383 c-7 -2 -13 -12 -12 -21 l1 -17 5 13 c2 6 11 12 19 12 8 0
14 5 14 10 0 11 -7 12 -27 3z"
      />
      <path
        d="M460 356 c0 -2 7 -9 15 -16 l15 -12 0 16 0 16 -15 0 c-8 0 -15 -2
-15 -4z"
      />
      <path d="M630 346 c0 -9 7 -19 15 -23 25 -9 27 2 5 22 l-20 18 0 -17z" />
      <path
        d="M770 320 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M800 320 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M920 320 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4
-16 -10z"
      />
      <path
        d="M470 305 l-12 -15 16 0 16 0 0 15 c0 8 -2 15 -4 15 -2 0 -9 -7 -16
-15z"
      />
      <path
        d="M405 290 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4
-16 -10z"
      />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#4b3637"
      stroke="none"
    >
      <path
        d="M400 691 l-10 -20 0 -103 0 -104 12 -12 12 -12 57 0 57 0 6 -16 c3
-9 6 -38 6 -65 l0 -50 -16 -6 -16 -6 -8 13 -8 13 -17 -17 c-10 -9 -15 -19 -12
-22 7 -8 193 -7 217 1 37 12 20 20 -35 17 l-56 -4 -14 12 -15 12 0 42 c0 22 6
48 13 57 l13 17 57 3 58 4 -23 -17 c-42 -31 -60 -50 -53 -56 4 -4 11 1 16 11
6 9 19 17 30 17 11 0 22 7 26 16 l6 15 23 -5 24 -6 0 15 0 15 -21 0 -21 0 4
25 c6 30 -8 34 -17 5 l-6 -20 -139 0 -138 0 8 35 c4 19 6 35 4 35 -3 0 0 9 6
20 l11 20 -11 0 -11 0 17 18 18 17 -17 3 -17 3 0 40 0 39 70 0 70 0 0 10 0 10
-75 0 -74 0 -11 -19z"
      />
      <path
        d="M560 665 l0 -15 -65 0 -65 0 0 -12 0 -13 151 3 152 3 -6 -15 c-4 -9
-2 -16 2 -16 10 0 24 31 17 38 -3 2 -38 7 -78 10 l-73 5 -8 13 c-11 19 -27 18
-27 -1z"
      />
      <path
        d="M714 563 c-3 -16 -7 -34 -10 -40 -2 -7 1 -13 6 -13 5 0 11 8 14 18 2
9 7 27 11 40 l6 22 -10 0 c-6 0 -13 -12 -17 -27z"
      />
      <path
        d="M254 567 c-3 -9 -4 -23 -2 -31 l3 -16 29 15 c37 19 42 19 67 -6 11
-11 23 -18 27 -14 7 7 -46 55 -62 55 -6 0 -21 3 -33 6 l-23 6 -6 -15z m23 -24
c-4 -3 -7 0 -7 7 0 7 3 10 7 7 3 -4 3 -10 0 -14z"
      />
      <path
        d="M800 496 c0 -3 11 -17 24 -31 l25 -27 10 7 c6 3 11 11 11 16 0 6 -4
8 -9 4 -5 -3 -12 -1 -16 5 -7 11 -45 33 -45 26z"
      />
      <path
        d="M745 479 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
      />
      <path
        d="M890 460 c0 -6 4 -10 9 -10 5 0 13 -9 16 -20 3 -11 10 -20 15 -20
l10 0 -12 24 c-11 25 -38 43 -38 26z"
      />
      <path
        d="M313 423 c-26 -26 -70 -53 -86 -53 -8 0 -14 -7 -14 -15 l0 -16 11 6
c6 3 19 8 29 11 9 4 17 11 17 16 l0 10 20 -5 20 -5 0 11 c0 6 7 19 17 29 22
24 10 35 -14 11z"
      />
      <path
        d="M350 435 c0 -3 8 -13 19 -24 l18 -18 32 1 c17 0 31 4 31 9 0 8 -14
10 -47 7 l-23 -1 0 15 0 16 -15 0 c-8 0 -15 -2 -15 -5z"
      />
      <path
        d="M450 365 c0 -8 6 -15 14 -15 8 0 16 -6 19 -12 l4 -13 8 7 8 8 -18 20
c-22 24 -35 26 -35 5z"
      />
      <path
        d="M626 345 c6 -15 44 -41 44 -30 0 6 -38 45 -45 45 -2 0 -2 -7 1 -15z"
      />
      <path
        d="M930 330 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3
-11 1 -19 -4z"
      />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#bebab2"
      stroke="none"
    >
      <path
        d="M408 618 l4 -78 9 0 c6 0 7 5 4 10 -3 6 -1 10 5 10 l11 0 -6 20 -6
20 11 0 11 0 -6 20 -6 20 95 0 96 0 0 10 c0 6 -13 10 -30 10 l-30 0 0 18 0 18
-82 0 -83 -1 3 -77z"
      />
      <path
        d="M720 600 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M710 560 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z"
      />
      <path d="M410 480 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path
        d="M846 448 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
      />
      <path
        d="M726 428 c3 -4 9 -8 15 -8 5 0 9 4 9 8 0 5 -7 9 -15 9 -8 0 -12 -4
-9 -9z"
      />
      <path d="M913 433 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M313 413 l0 -13 14 11 c7 6 13 12 13 14 0 1 -6 2 -13 2 -8 0 -14 -6
-14 -14z"
      />
      <path
        d="M683 415 c0 -8 4 -12 9 -9 4 3 8 9 8 15 0 5 -4 9 -8 9 -5 0 -9 -7 -9
-15z"
      />
      <path
        d="M920 410 c0 -5 7 -10 15 -10 l15 0 0 -36 0 -35 10 6 c16 10 11 51 -8
68 -21 19 -32 22 -32 7z"
      />
      <path d="M706 385 l-20 -15 16 0 c8 0 21 7 28 15 16 19 1 19 -24 0z" />
      <path d="M890 390 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path
        d="M255 370 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"
      />
      <path d="M441 356 l-12 -14 20 5 c12 3 18 9 15 14 -7 12 -10 11 -23 -5z" />
      <path
        d="M216 344 l-16 -16 7 -11 7 -11 4 14 c3 8 9 21 15 28 14 17 1 15 -17
-4z"
      />
      <path
        d="M480 325 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z"
      />
      <path
        d="M225 290 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0
6 -10z"
      />
      <path d="M344 288 c-3 -4 9 -8 26 -8 l31 0 -6 9 c-6 11 -44 10 -51 -1z" />
      <path
        d="M415 290 l-6 -10 25 0 c14 0 26 5 26 10 0 6 -9 10 -19 10 -11 0 -23
-4 -26 -10z"
      />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#3787bf"
      stroke="none"
    >
      <path
        d="M550 703 c0 -14 19 -38 25 -32 8 8 -5 39 -16 39 -5 0 -9 -3 -9 -7z"
      />
      <path
        d="M392 575 l-2 -111 12 -12 12 -12 58 0 58 0 6 -26 c4 -14 4 -45 1 -70
l-5 -44 9 0 9 0 0 61 0 60 10 -6 10 -6 6 16 6 16 77 -3 76 -2 28 27 c15 16 27
30 27 32 0 14 -24 2 -47 -22 l-26 -28 -4 13 c-3 6 -9 12 -14 12 -4 0 -6 -6 -4
-12 l5 -13 -60 3 -61 4 -13 -11 -12 -11 -10 10 c-5 5 -38 10 -74 12 l-65 3 -6
115 -5 115 -2 -110z"
      />
      <path
        d="M735 630 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
      />
      <path
        d="M725 580 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"
      />
      <path
        d="M259 576 c-1 -3 -2 -9 -3 -13 -1 -5 -5 -14 -10 -21 -4 -7 -5 -16 -1
-20 9 -9 26 21 20 37 l-5 14 12 -10 13 -10 25 8 c14 4 18 8 10 8 -8 1 -25 4
-37 7 -13 4 -24 4 -24 0z"
      />
      <path
        d="M335 550 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
      />
      <path
        d="M715 540 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"
      />
      <path
        d="M363 525 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9 -1
-9 -9z"
      />
      <path
        d="M700 500 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M833 465 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9 -1
-9 -9z"
      />
      <path
        d="M330 430 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M297 410 c-22 -26 -22 -33 1 -19 10 7 19 18 19 25 0 17 1 18 -20 -6z"
      />
      <path
        d="M463 366 c0 -8 5 -14 11 -13 6 1 10 -4 9 -10 -2 -7 2 -13 7 -13 16 0
12 15 -8 33 l-19 17 0 -14z"
      />
      <path
        d="M620 365 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z"
      />
      <path
        d="M770 320 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z"
      />
      <path
        d="M805 320 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
      />
      <path
        d="M485 310 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"
      />
      <path
        d="M460 289 c0 -11 91 -15 160 -8 l65 6 -55 2 c-146 6 -170 6 -170 0z"
      />
      <path d="M408 283 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z" />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#9dcced"
      stroke="none"
    >
      <path d="M638 853 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z" />
      <path
        d="M484 834 l-19 -15 25 12 c31 14 36 19 24 19 -6 0 -19 -7 -30 -16z"
      />
      <path
        d="M635 830 c-3 -6 -1 -10 4 -10 6 0 11 -4 11 -10 0 -5 -9 -10 -20 -10
-11 0 -20 -4 -20 -10 l0 -10 68 0 c37 0 73 -4 80 -10 7 -5 -2 5 -20 24 l-33
34 -32 5 -32 6 -6 -9z"
      />
      <path d="M414 768 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z" />
      <path d="M390 720 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path d="M781 714 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
      <path
        d="M300 713 c-28 -11 -70 -44 -81 -65 l-11 -21 36 36 36 36 37 6 c54 9
63 13 28 13 -16 0 -37 -2 -45 -5z"
      />
      <path d="M791 674 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
      <path
        d="M848 623 c17 -17 32 -37 32 -44 0 -7 3 -9 6 -6 10 9 -23 54 -48 68
l-23 12 33 -30z"
      />
      <path d="M200 610 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path d="M173 583 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M149 573 c-5 -29 -2 -39 11 -45 l15 -7 -22 0 c-27 -1 -28 -7 -9 -27
17 -16 36 -19 36 -4 l0 10 41 0 40 0 -3 18 -3 17 -39 3 c-38 3 -71 23 -59 36
4 3 3 6 0 6 -4 0 -8 -3 -8 -7z"
      />
      <path
        d="M107 513 c-13 -12 -7 -69 9 -89 l15 -19 -12 24 -11 24 5 33 c6 35 5
39 -6 27z"
      />
      <path d="M157 379 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z" />
      <path
        d="M190 366 c0 -2 11 -6 25 -8 14 -3 25 -1 25 3 0 5 -11 9 -25 9 -14 0
-25 -2 -25 -4z"
      />
      <path
        d="M871 274 c-19 -13 -29 -24 -23 -24 6 0 24 11 39 25 35 31 28 31 -16
-1z"
      />
      <path d="M766 251 l-6 -9 20 5 c23 6 26 13 6 13 -8 0 -17 -4 -20 -9z" />
      <path
        d="M289 217 c25 -27 80 -58 103 -56 7 0 0 5 -17 11 -16 6 -48 24 -70 41
l-40 31 24 -27z"
      />
      <path
        d="M729 213 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
      />
      <path
        d="M614 206 c11 -9 27 -16 35 -15 l16 1 -15 5 c-8 3 -24 10 -35 15 l-20
9 19 -15z"
      />
      <path
        d="M529 193 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
      />
      <path d="M678 193 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z" />
      <path d="M458 163 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z" />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#3e668a"
      stroke="none"
    >
      <path
        d="M560 677 c0 -8 7 -14 15 -14 l15 0 -11 14 c-6 7 -13 13 -15 13 -2 0
-4 -6 -4 -13z"
      />
      <path
        d="M690 656 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6
0 -15z"
      />
      <path d="M734 628 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z" />
      <path
        d="M720 590 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M271 574 c0 -5 4 -18 8 -28 l8 -20 5 10 c4 5 0 18 -8 29 -8 10 -14
15 -13 9z"
      />
      <path
        d="M340 550 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z"
      />
      <path
        d="M710 550 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path d="M253 543 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M360 484 l0 -37 -17 -14 -18 -14 23 4 23 5 7 -16 c4 -9 13 -18 20
-19 17 -4 15 14 -3 21 l-15 5 0 51 0 50 -10 0 -10 0 0 -36z"
      />
      <path
        d="M700 504 l0 -15 10 6 c6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0 -10 -7
-10 -16z"
      />
      <path
        d="M775 490 l-6 -10 20 0 c12 0 21 5 21 10 0 6 -6 10 -14 10 -8 0 -18
-4 -21 -10z"
      />
      <path
        d="M820 480 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z"
      />
      <path
        d="M690 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M860 460 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M728 453 c-25 -6 -23 -22 2 -20 11 1 20 7 20 14 0 7 -1 12 -2 12 -2
-1 -11 -3 -20 -6z"
      />
      <path
        d="M560 440 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M677 426 c-21 -16 -22 -26 -1 -26 8 0 13 4 10 9 -4 5 0 11 6 14 7 2
11 7 8 10 -3 3 -13 0 -23 -7z"
      />
      <path
        d="M440 405 c0 -18 19 -40 26 -32 4 4 0 15 -9 24 -9 10 -17 13 -17 8z"
      />
      <path d="M634 398 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z" />
      <path
        d="M246 374 c-11 -7 -18 -16 -15 -18 2 -2 13 2 23 10 11 7 18 16 15 18
-2 2 -13 -2 -23 -10z"
      />
      <path d="M625 371 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z" />
      <path
        d="M635 330 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"
      />
      <path
        d="M660 320 c0 -5 7 -10 15 -10 8 0 15 -5 15 -12 l0 -12 12 12 c7 7 27
12 45 12 l33 0 0 10 0 10 -60 0 -60 0 0 -10z"
      />
      <path
        d="M810 320 l0 -10 45 0 c25 0 48 0 52 -1 4 0 9 4 11 10 l4 11 -56 0
-56 0 0 -10z"
      />
      <path
        d="M539 317 c-7 -16 -4 -37 6 -41 l13 -5 6 15 c3 8 7 17 8 21 3 5 -30
15 -33 10z"
      />
      <path
        d="M450 290 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#cde5f5"
      stroke="none"
    >
      <path d="M573 863 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
      <path d="M515 850 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
      <path d="M657 840 c7 -27 19 -33 40 -22 l16 10 -30 16 -31 15 5 -19z" />
      <path
        d="M605 830 l-6 -10 21 0 21 0 -6 10 c-3 6 -10 10 -15 10 -5 0 -12 -4
-15 -10z"
      />
      <path
        d="M440 805 c-19 -22 -8 -25 13 -3 9 10 13 18 8 18 -5 0 -14 -7 -21 -15z"
      />
      <path
        d="M760 764 c0 -6 7 -19 16 -30 l15 -19 -12 25 c-14 31 -19 36 -19 24z"
      />
      <path d="M304 708 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z" />
      <path d="M786 697 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z" />
      <path d="M253 683 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M790 660 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z"
      />
      <path d="M220 650 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path d="M833 633 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path d="M870 600 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path d="M886 567 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z" />
      <path
        d="M156 549 l6 -11 -22 4 -23 3 -8 -23 -9 -23 12 7 c6 4 42 6 79 5 l69
-2 -5 13 c-7 17 -52 38 -83 38 l-23 0 7 -11z m71 -26 c-4 -3 -10 -3 -14 0 -3
4 0 7 7 7 7 0 10 -3 7 -7z"
      />
      <path d="M902 510 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
      <path
        d="M105 440 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0
-2 -4 1 -10z"
      />
      <path
        d="M120 411 c0 -10 29 -36 34 -30 1 2 -6 12 -16 22 -10 9 -18 13 -18 8z"
      />
      <path d="M177 369 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z" />
      <path d="M900 300 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path d="M250 271 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z" />
      <path d="M863 263 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M560 225 l-12 -15 11 0 c6 0 11 5 11 11 l0 11 15 -12 c9 -7 17 -11
20 -9 2 3 -4 10 -15 16 l-18 12 -12 -14z"
      />
      <path
        d="M625 200 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0
-2 -4 1 -10z"
      />
      <path d="M713 203 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path d="M313 193 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M500 180 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5 0
-17 -5 -25 -10z"
      />
      <path
        d="M365 170 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0
-2 -4 1 -10z"
      />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#4ea5de"
      stroke="none"
    >
      <path d="M533 853 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M650 840 c-7 -4 -19 -6 -26 -3 -6 2 -14 0 -18 -5 l-5 -9 22 3 c12 1
32 -5 45 -12 l22 -14 0 10 c0 5 -5 10 -11 10 -5 0 -8 4 -4 9 8 14 -9 21 -25
11z"
      />
      <path d="M464 818 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z" />
      <path
        d="M715 790 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
      />
      <path d="M424 778 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z" />
      <path d="M384 708 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z" />
      <path d="M790 660 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path
        d="M127 550 l-12 -15 15 11 15 10 35 -7 35 -6 -25 -2 -25 -1 13 -9 c7
-4 25 -6 39 -3 l25 5 -16 9 c-9 5 -15 12 -12 16 2 4 -14 7 -36 7 l-40 0 -11
-15z"
      />
      <path d="M890 550 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path
        d="M130 516 c0 -2 7 -9 15 -16 l15 -12 0 16 0 16 -15 0 c-8 0 -15 -2
-15 -4z"
      />
      <path
        d="M885 470 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
      />
      <path d="M904 308 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z" />
      <path
        d="M330 288 c0 -5 18 -8 40 -8 22 0 40 2 40 4 0 2 -18 6 -40 8 -22 2
-40 0 -40 -4z"
      />
      <path
        d="M749 233 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
      />
      <path
        d="M554 218 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
      />
      <path d="M393 163 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path d="M443 163 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#584b4d"
      stroke="none"
    >
      <path
        d="M406 701 c-3 -5 1 -11 9 -15 8 -3 15 -1 15 4 0 13 -18 22 -24 11z"
      />
      <path
        d="M555 689 c11 -35 14 -36 83 -41 l62 -4 0 14 0 14 -65 -4 -65 -3 0 17
c0 9 -5 20 -11 24 l-11 7 7 -24z"
      />
      <path d="M426 604 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z" />
      <path
        d="M727 603 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9
2 -12 -2z"
      />
      <path
        d="M420 569 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
      />
      <path d="M244 538 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z" />
      <path
        d="M345 540 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0
-7 -4 -4 -10z"
      />
      <path
        d="M410 535 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z"
      />
      <path d="M410 500 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path d="M700 500 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path
        d="M752 474 c-22 -25 -9 -31 15 -6 l22 22 -12 0 c-7 -1 -18 -7 -25 -16z"
      />
      <path
        d="M690 469 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
      />
      <path d="M833 453 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M530 441 c0 -11 26 -22 34 -14 12 12 5 23 -14 23 -11 0 -20 -4 -20
-9z"
      />
      <path d="M371 416 l13 -28 4 12 c3 7 -3 19 -13 28 l-16 17 12 -29z" />
      <path d="M690 430 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path d="M713 433 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path d="M333 423 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M915 410 l-6 -10 16 0 c8 0 18 -7 21 -15 4 -8 10 -15 15 -15 l10 0
-10 19 c-12 22 -38 34 -46 21z"
      />
      <path
        d="M446 385 c4 -8 10 -15 15 -15 4 0 6 7 3 15 -4 8 -10 15 -15 15 -4 0
-6 -7 -3 -15z"
      />
      <path d="M631 364 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
      <path d="M234 358 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z" />
      <path
        d="M946 345 c-3 -8 -1 -15 3 -15 5 0 11 7 15 15 3 8 1 15 -3 15 -5 0
-11 -7 -15 -15z"
      />
      <path
        d="M213 326 l2 -29 15 -5 15 -5 -11 14 c-7 8 -14 23 -17 34 l-6 20 2
-29z"
      />
      <path
        d="M687 310 c3 -12 6 -19 7 -18 1 2 8 11 15 21 l13 17 -20 0 -20 0 5
-20z"
      />
      <path
        d="M535 310 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
      />
      <path d="M543 283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#75b9e6"
      stroke="none"
    >
      <path
        d="M665 840 c3 -6 1 -10 -4 -10 -6 0 -11 -8 -10 -17 l1 -18 5 13 5 13
16 -13 17 -13 -13 17 -13 16 13 4 12 4 -18 7 -17 7 6 -10z"
      />
      <path d="M613 833 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M120 538 c0 -4 14 -8 30 -8 17 0 30 2 30 4 0 2 -13 6 -30 8 -16 3
-30 1 -30 -4z"
      />
      <path
        d="M195 530 c-3 -5 -15 -10 -26 -10 l-19 0 1 -22 1 -23 5 18 5 19 49 -4
c27 -1 49 0 49 5 0 4 -14 7 -31 7 l-30 0 6 10 c3 6 4 10 1 10 -3 0 -8 -4 -11
-10z"
      />
      <path d="M233 533 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path d="M100 480 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path d="M245 280 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z" />
      <path d="M658 193 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z" />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#a3978f"
      stroke="none"
    >
      <path
        d="M480 690 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0
-20 -4 -20 -10z"
      />
      <path
        d="M568 658 c5 -5 35 -11 68 -14 l61 -7 0 14 0 14 -68 0 c-37 0 -65 -3
-61 -7z"
      />
      <path
        d="M430 620 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M420 586 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6
0 -15z"
      />
      <path d="M723 593 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M710 549 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
      />
      <path
        d="M410 540 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z"
      />
      <path d="M788 483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z" />
      <path d="M343 423 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path d="M746 405 l-20 -15 13 0 c7 0 19 7 27 15 20 19 5 19 -20 0z" />
      <path d="M668 403 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z" />
      <path d="M896 401 l-6 -9 20 5 c23 6 26 13 6 13 -8 0 -17 -4 -20 -9z" />
      <path d="M684 368 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z" />
      <path
        d="M485 320 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
      />
      <path
        d="M688 323 c17 -2 47 -2 65 0 17 2 3 4 -33 4 -36 0 -50 -2 -32 -4z"
      />
      <path
        d="M815 325 c6 -2 34 -5 63 -8 l52 -4 0 8 0 9 -62 -1 c-35 0 -58 -2 -53
-4z"
      />
      <path d="M231 294 c13 -16 29 -19 29 -5 0 5 -9 11 -21 14 l-20 5 12 -14z" />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#847470"
      stroke="none"
    >
      <path
        d="M545 700 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
      />
      <path
        d="M420 690 l0 -10 55 2 c30 1 55 6 55 10 0 4 -25 8 -55 8 l-55 0 0 -10z"
      />
      <path d="M624 648 l-6 -9 27 5 c37 7 42 14 10 14 -14 0 -28 -5 -31 -10z" />
      <path d="M430 624 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z" />
      <path d="M423 585 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z" />
      <path d="M714 548 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z" />
      <path
        d="M415 530 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"
      />
      <path
        d="M700 509 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
      />
      <path d="M410 490 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path d="M690 470 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path
        d="M865 460 l-6 -10 20 0 c12 0 21 5 21 10 0 6 -6 10 -14 10 -8 0 -18
-4 -21 -10z"
      />
      <path d="M740 440 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path d="M354 428 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z" />
      <path d="M373 413 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M940 400 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z"
      />
      <path d="M443 393 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M953 365 c0 -8 4 -15 9 -15 4 0 8 7 8 15 0 8 -4 15 -8 15 -5 0 -9 -7
-9 -15z"
      />
      <path
        d="M446 362 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"
      />
      <path
        d="M940 329 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
      />
      <path
        d="M915 320 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
      />
      <path
        d="M236 288 c3 -4 9 -8 15 -8 5 0 9 4 9 8 0 5 -7 9 -15 9 -8 0 -12 -4
-9 -9z"
      />
      <path
        d="M450 289 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
      />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#48566b"
      stroke="none"
    >
      <path
        d="M406 702 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"
      />
      <path d="M544 698 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z" />
      <path d="M280 540 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path d="M347 539 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z" />
      <path d="M363 475 l0 -50 4 28 c2 15 2 37 0 50 -2 12 -4 0 -4 -28z" />
      <path d="M703 513 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path
        d="M870 460 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M530 440 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z"
      />
      <path d="M303 403 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path d="M400 400 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path
        d="M450 369 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
      />
      <path
        d="M486 325 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 l-9 0 5
-15z"
      />
      <path d="M557 301 l-6 -24 11 11 c5 5 8 16 6 23 l-4 13 -7 -23z" />
      <path d="M533 303 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path d="M250 290 l0 -10 45 0 45 0 0 10 0 10 -45 0 -45 0 0 -10z" />
      <path
        d="M435 290 l-20 -9 23 0 c12 -1 22 4 22 9 0 6 -1 10 -2 9 -2 0 -12 -4
-23 -9z"
      />
      <path d="M373 283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#b3aba2"
      stroke="none"
    >
      <path
        d="M421 696 c7 -8 118 -10 126 -3 3 4 -24 7 -62 7 -38 0 -66 -2 -64 -4z"
      />
      <path d="M623 643 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path d="M754 468 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z" />
      <path d="M873 453 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
      <path d="M450 370 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
      <path d="M273 293 c15 -2 37 -2 50 0 12 2 0 4 -28 4 l-50 0 28 -4z" />
    </g>
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#c8991c"
      stroke="none"
    >
      <path
        d="M545 440 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'OneDriveFileIcon',
};
</script>
